import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h3 {...{
      "id": "setting-event-properties"
    }}>{`Setting event properties`}</h3>
    <p>{`Optionally, you can include additional information with the event by including a  `}<a parentName="p" {...{
        "href": "/docs/data/events#event-properties"
      }}>{`properties`}</a>{` object:`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      